module.exports = __webpack_public_path__ + "media/images/empty-9726338f80237d1430d0e8c4a418151a.svg";